@if ((isAuthenticated$ | async) === false) {
  <div class="bg-(--background-color) h-full">
    @if (state() === authenticateState.SIGN_IN_AND_SIGN_UP) {
      <keus-sign-in-and-sign-up
        (signInEvent)="changeAuthState($event)"
        class="h-full"
      ></keus-sign-in-and-sign-up>
    }

    @if (state() === authenticateState.CONFIRM_SIGN_UP) {
      <keus-confirm-sign-up
        (confirmSignUpEvent)="changeAuthState($event)"
        class="h-full"
      />
    }

    @if (state() === authenticateState.RESET_PASSWORD) {
      <keus-reset-password
        (resetPasswordEvent)="changeAuthState($event)"
        class="h-full"
      />
    }
  </div>
} @else {
  <ng-container
    [ngTemplateOutlet]="authContent?.templateRef ?? null"
  ></ng-container>
}